export function formatEventDate (dateString, format, timezone = 'UTC') {
  if (!dateString) return ''

  try {
    // ----------------------------------------------------
    // 1) Normalizza l'input (supporta: solo data, data+ora)
    // ----------------------------------------------------
    // Esempi validi:
    // 2025-04-03
    // 2025-04-03 15:22:00
    // 2025-04-03T15:22:00Z

    let clean = dateString.trim()

    // Se arriva "2025-04-03 15:22:00" → 2025-04-03T15:22:00
    if (clean.includes(' ') && !clean.includes('T')) {
      clean = clean.replace(' ', 'T')
    }

    // Se manca il fuso, aggiungiamo Z (evita Invalid Date)
    if (!clean.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(clean)) {
      clean = clean + 'Z'
    }

    const date = new Date(clean)

    if (isNaN(date)) {
      // console.warn('Data non valida:', dateString)
      return dateString
    }

    // ----------------------------------------------------
    // 2) Convertiamo nel fuso dell’evento (se servisse)
    // ----------------------------------------------------
    const local = new Date(date.toLocaleString('en-US', { timeZone: timezone }))

    const YYYY = local.getFullYear()
    const MM = String(local.getMonth() + 1).padStart(2, '0')
    const DD = String(local.getDate()).padStart(2, '0')

    const HH = String(local.getHours()).padStart(2, '0')
    const mm = String(local.getMinutes()).padStart(2, '0')
    const ss = String(local.getSeconds()).padStart(2, '0')

    // ----------------------------------------------------
    // 3) Applichiamo SOLO ciò che è previsto dal formato
    // ----------------------------------------------------
    const out = format
      .replace(/YYYY/g, YYYY)
      .replace(/MM/g, MM)
      .replace(/DD/g, DD)
      .replace(/HH/g, HH)
      .replace(/mm/g, mm)
      .replace(/ss/g, ss)

    return out
  } catch (err) {
    // console.error('Errore formatEventDate():', err)
    return dateString
  }
}
